var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pageWrapEl",staticClass:"page-wrap"},[(_setup.showHeader)?_c('div',{staticClass:"page-header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"page-content__outer",style:({
      padding: _vm.noPadding ? '0px' : '24px'
    })},[_c('div',{ref:"pageInnerpEl",staticClass:"page-content__inner",style:({
        'min-height': _setup.minHeight + 'px',
        padding: _vm.noContentPadding ? '0px' : ''
      })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }